import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  ::selection {
    background-color: ${({ theme }) => theme.colors.secondary};
    color: #fff;
  }

  html, body {
    margin: 0;
    padding: 0;
    min-height: 100vh;
    scroll-behavior: smooth;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.text};
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${({ theme }) => theme.colors.background};
  }

  .section {
    padding: ${({ theme }) => theme.spacing(4)} 0;
    ${({ theme }) => theme.breakpoints.getMax('md')} {
      padding: ${({ theme }) => theme.spacing(3)} 0;
    }
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing(2)};
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  .fadeIn {
    animation: fadeIn 0.5s ease-in-out;
  }

  // Typography styles
  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    margin: 0;
  }

  h1 { 
    font-size: ${({ theme }) => theme.fontSizes.h1};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }

  h2 { 
    font-size: ${({ theme }) => theme.fontSizes.h2};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  h3 { 
    font-size: ${({ theme }) => theme.fontSizes.h3};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  h4 { 
    font-size: ${({ theme }) => theme.fontSizes.h4};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  h5 { 
    font-size: ${({ theme }) => theme.fontSizes.h5};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  h6 { 
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }

  p {
    font-size: ${({ theme }) => theme.fontSizes.body1};
    line-height: ${({ theme }) => theme.lineHeights.body};
    margin: 0;
  }
`;
